import React from 'react';
import { Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Button, Skeleton } from 'seduo-ui';
const Example = (props) => (<div>
        <Card style={{
        width: '318px',
    }}>
            <CardImg top width="100%" src="https://dummyimage.com/318x180/9fa4a8/fff.png" alt="Card image cap"/>
            <CardBody>
                <CardTitle>Card title</CardTitle>
                <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>
                    Some quick example text to build on the card title and make up the bulk of the card's content.
                </CardText>
                <Button>Button</Button>
            </CardBody>
        </Card>

        <Card style={{
        width: '318px',
    }}>
            <CardImg top width="100%" height="180px" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" alt="Card image cap" className="skeleton"/>
            <CardBody>
                <CardTitle>
                    <Skeleton type="title"/>
                </CardTitle>
                <CardSubtitle>
                    <Skeleton type="title"/>
                </CardSubtitle>
                <CardText>
                    <Skeleton lines={3}/>
                </CardText>
                <Button>Button</Button>
            </CardBody>
        </Card>
    </div>);
export default Example;
